import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

/**
 * A service to control the tab bar that's present in most core function pages.
 */
@Injectable({
  providedIn: 'root'
})
export class TabBarService {

  private _display: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private _guideLink: Subject<string> = new BehaviorSubject<string>('user');

  constructor() {
  }

  public show(guideLink: 'user' | 'admin' = 'user') {
    this._display.next(true);
    this._guideLink.next(guideLink);
  }

  public hide() {
    this._display.next(false);
  }

  public hideGuideLink() {
    this._guideLink.next(null);
  }

  public get display(): Subject<boolean> {
    return this._display;
  }

  public get guideLink(): Observable<string> {
    return this._guideLink;
  }

}
